<template>
    <!-- <img src="/images/pessoalform_logo.svg" alt="pessoalform logo" /> -->
    <object data="/images/pessoalform_logo.svg" type="image/svg+xml"></object>
</template>
